import React, { useEffect, useState, useRef } from "react";
import { fetchGrouptripsCity_list } from "../services/GrouptripsCity_list";
import { API_BASE } from "../api/apiConfig";

const Meetupspagecitydata = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      const res = await fetchGrouptripsCity_list();
      console.log("🔥 API RESPONSE:", res);

      if (res?.status === true && Array.isArray(res.data)) {
        const flatCities = res.data.flatMap(item => item.city || []);
        console.log("✅ FLATTENED:", flatCities);
        setCities(flatCities);
      }
    } catch (err) {
      console.error("❌ API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  const scrollRef = useRef(null);

  const scrollLeftFn = () => {
    scrollRef.current.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRightFn = () => {
    scrollRef.current.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <p className="text-center py-10">Loading cities...</p>;
  }

  return (
      <>
{/* Desktop */}
<div className="hidden sm:block">
  <section className="pt-16 pb-10 md:pt-20 bg-gradient-to-b from-slate-50 to-white">
    <div className="container mx-auto px-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center shadow-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-sparkles h-5 w-5 text-white"
            >
              <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
              <path d="M5 3v4" />
              <path d="M19 17v4" />
              <path d="M3 5h4" />
              <path d="M17 19h4" />
            </svg>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-slate-900">
              Top Destinations
            </h2>
            <p className="text-sm text-slate-500">
              Explore group &amp; customized trips
            </p>
          </div>
        </div>
        <a
          className="text-teal-600 text-sm font-medium flex items-center gap-1 hover:underline"
          href="/grouptrips"
        >
          View all
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right h-4 w-4"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </a>
      </div>
      <div className="relative -mx-4 px-4 sm:-mx-5 sm:px-5 md:-mx-4 md:px-4 relative">
        <button onClick={scrollLeftFn}
            className="absolute -left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-0"
            aria-label="Previous meetups"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
          
          <div ref={scrollRef}
            className="flex snap-x snap-mandatory gap-3 md:gap-4 overflow-x-auto pb-6 scrollbar-hide experience-trips-container"
            style={{ scrollbarWidth: "none" }}
          >
          
          {cities.map(city => (
            <a className="flex-shrink-0 group" href={`/DestinationsDetail/${city.city}`}>
              <div className="relative w-48 h-56 overflow-hidden rounded-2xl shadow-lg">
                <img
                  alt={city.city}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-110 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src={`${API_BASE}/${city.cover_image}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-bold text-lg mb-1">{city.city}</h3>
                  <div className="flex items-center gap-1.5 text-white/80">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3.5 w-3.5"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="text-sm">{city.toure_count} trips available</span>
                  </div>
                </div>
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-teal-400 rounded-2xl transition-all duration-300" />
              </div>
            </a>
           ))}


          </div>
        <button onClick={scrollRightFn}
            className="absolute -right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-0"
            aria-label="Next meetups"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>
      </div>
    </div>
  </section>
</div>


{/* Mobile */}
<div className="block sm:hidden">
  <section className="px-4 pt-8 mb-10 pb-6 border-b border-slate-100">
    <div className="flex items-center justify-between mb-3">
      <div>
        <h3 className="text-lg font-bold text-slate-800">
          Explore by Destination
        </h3>
        <p className="text-xs text-slate-500">Find trips to your dream place</p>
      </div>
      <a
        className="text-teal-600 text-xs font-medium flex items-center gap-1"
        href="/grouptrips"
      >
        All
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-chevron-right h-3 w-3"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </a>
    </div>
    <div className="flex gap-3 scrollbar-custom pb-2">
    {cities.map(city => (
      <a className="flex-shrink-0 w-28" href={`/DestinationsDetail/${city.city}`}>
        <div className="relative h-36 rounded-xl overflow-hidden shadow-md group">
          <img
            alt={city.city}
            loading="lazy"
            decoding="async"
            data-nimg="fill"
            className="object-cover group-hover:scale-110 transition-transform duration-300"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              inset: 0,
              color: "transparent"
            }}
            src={`${API_BASE}/${city.cover_image}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-2.5">
            <h4 className="text-white font-bold text-sm leading-tight">
               {city.city}
            </h4>
            <p className="text-white/80 text-xs">{city.toure_count} trips</p>
          </div>
        </div>
      </a>
    ))}
    </div>
  </section>

</div>

    </>
  );
};

export default Meetupspagecitydata;
